/**
 * @ngdoc directive
 * @description Mirror models to other models leveraging ngModel. Optionally transform the model values with a passed in function.
 * @param $parse
 */
export default function modelMirrorDirective() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      //Models to mirror, can be single, or csl model1, model2, model3
      modelMirror: '=',
      //Function to be applied to model values, the return value then becomes the $modelValue
      modelMirrorTransform: '&',
      //Options to change behavior of this modelMirror directive.
      modelMirrorOptions: '='
    },
    require: 'ngModel',
    /**
     * @description Watch models, update current model with changes.
     * @param $scope
     * @param $element
     * @param $attrs
     * @param $modelCtrl
     */
    link: function ($scope, $element, $attrs, $modelCtrl) {
      //Replace options from incoming options
      let options = Object.assign({
          defaultSpaces: true,
        }, $scope.modelMirrorOptions),
        //If multiple models are being mirrored
        multiModel = false,
        //If a change has occurred that we haven't mirrored.
        dirty = false;

      /**
       * @description default transform function.
       * @param models
       */
      function defaultTransform(models) {
        let sep = options.defaultSpaces ? ' ' : '';
        return models.reduce(function (prev, curr, index) {
          return index === 0 ? `${curr}` : `${prev}${sep}${curr}`;
        }, '');
      }

      /**
       * @description Transform the incoming model values and set the local model value
       */
      function setValue() {
        if (dirty) {
          let result;
          try {
            if (multiModel) {
              result = options.transformFn($scope.modelMirror);
            }
            else {
              result = options.transformFn([$scope.modelMirror]);
            }
            dirty = false;
          }
          catch (e) {
            console.error(e.message);
          }
          if (result) {
            $modelCtrl.$setViewValue(result);
            $modelCtrl.$render();
          }
        }
      }

      if ($attrs.modelMirrorTransform) {
        options.transformFn = $scope.modelMirrorTransform();
      }else{
        options.transformFn = defaultTransform;
      }

      if (Array.isArray($scope.modelMirror)) {
        multiModel = true;
        $scope.$watchCollection('modelMirror', function () {
          dirty = true;
          setValue();
        });
      }
      else {
        $scope.$watch('modelMirror', function () {
          dirty = true;
          setValue();
        });
      }
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/modelMirror/modelMirror.directive.js
 **/